import validate from "/tmp/build_96f1cc98/node_modules/nuxt/dist/pages/runtime/validate.js";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {
  auth: () => import("/tmp/build_96f1cc98/node_modules/@sidebase/nuxt-auth/dist/runtime/middleware/auth.mjs")
}